$(function() {

    const prevArrow = $(".js-main-prev-btn");
    const nextArrow = $(".js-main-next-btn");

    $('.js-main-slider').slick({
        slidesToShow: 1,
        arrows: true,
        dots: false,
        prevArrow: !!prevArrow.length && prevArrow,
        nextArrow: !!nextArrow.length && nextArrow,
        autoplay: true,
    })
})
